import { render, staticRenderFns } from "./TextFixedIcon.vue?vue&type=template&id=71e4aefe&"
import script from "./TextFixedIcon.vue?vue&type=script&lang=js&"
export * from "./TextFixedIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports